import { FormVmItemConfigType, FormVmValueFormatterType, FormVmValueValidatorResultType } from '../../../../../../infrastructure/form-viewmodel-controller';
import { InputValidatorType, maxCharactersValidator, stringValueRequired } from '../../../../../../modules/validators';
import { OrganizationLinkType } from './organization-link.mapper';


export const ENCODE_FREE_CHAR_REGEX = /[^a-zA-Z0-9\/:@~_.\-!$&()*+,;="']/g;
export const ENCODED_CHARACTERS_MAX_LENGTH = 300;


export const organizationLinkIsRequired: InputValidatorType = (val: string, type: OrganizationLinkType): FormVmValueValidatorResultType => {
    const valid = stringValueRequired(val);
    const validationMessage = valid
        ? null :
        {
            id: {
                [OrganizationLinkType.Presenter]: 'oe.common.orgPresenterLinkPathIsRequired',
                [OrganizationLinkType.Participant]: 'oe.common.orgParticipantLinkPathIsRequired'
            }[type] || ''
        };

    return { valid: valid, validationMessage: validationMessage };
};


export const encodedLinkMaxLength = (val: string) => maxCharactersValidator(val, ENCODED_CHARACTERS_MAX_LENGTH);

export const trimSpacesRight: FormVmValueFormatterType<string> = val => String.prototype.trimRight.call(val || '');

export const encodeOrganizationLink = (value: string = ''): string => {
    try {
        return value?.replace(ENCODE_FREE_CHAR_REGEX, encodeURIComponent) ?? value;
    } catch (e) {
        return value;
    }
};

export const decodeOrganizationLink = (value: string = ''): string => {
    try {
        return decodeURIComponent(value);
    } catch (e) {
        return value;
    }
};


export const getConfigByType = (type: OrganizationLinkType): FormVmItemConfigType[] => [
    {
        name: type,
        validators: [ (value: string = '') => organizationLinkIsRequired(value, type), encodedLinkMaxLength ],
        formatters: [ encodeOrganizationLink ]
    }
];
